module.exports = __webpack_public_path__ + "static/media/backsplash1_lowres.36dabcf5.jpg";